import React from "react";

const AboutWrapper = () => {
  return (
    <>
      {/* =============== About wrapper start =============== */}
      <div className="about-wrapper mt-96">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-xl-9">
              <div className="position-relative" style={{ zIndex: 2 }}>
                <div
                  className="text-secondary"
                  style={{ lineHeight: "1.8", fontSize: "1.1rem" }}
                >
                  <p className="mb-4">
                    <strong className="text-dark">HypeNa</strong> is a Namibian
                    app built to connect people, businesses, and experiences
                    across the country. Designed as both an app and website, it
                    brings together upcoming events, lifestyle activities, and
                    fun experiences while also showcasing businesses from
                    Namibia’s main towns.
                  </p>
                  <p className="mb-4">
                    With HypeNa, convenience comes first. Namibians can discover
                    what’s happening around them and find services they need
                    without the endless search. At the same time, businesses
                    gain a powerful platform to market their goods and services
                    directly to their communities and beyond.
                  </p>

                  <div
                    className="mt-5 p-4 rounded-4 shadow-sm"
                    style={{
                      backgroundColor: "rgba(221, 121, 18, 0.05)",
                      borderLeft: "4px solid #DD7912",
                    }}
                  >
                    <h4 className="h5 fw-bold text-dark mb-3">
                      At its core, HypeNa stands for three things:
                    </h4>
                    <ul className="list-unstyled mb-0">
                      <li className="mb-3 d-flex align-items-center">
                        <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                        <span>Convenience for the Namibian people</span>
                      </li>
                      <li className="mb-3 d-flex align-items-center">
                        <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                        <span>
                          A platform for businesses to grow and be seen
                        </span>
                      </li>
                      <li className="d-flex align-items-center">
                        <i className="bi bi-check-circle-fill text-primary me-3 fs-5"></i>
                        <span>
                          Information sharing and exposure across towns and
                          industries
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AboutWrapper;
